export default __webpack_public_path__ + "static/media/tentacles.19a3edb4.svg";